import { useState, useEffect } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function PaymentPage() {

    const [paymentMethod, setPaymentMethod] = useState("COD");
    const [selectedAddress, setSelectedAddress] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        fetchSelectedAddress();
        fetchCart();
    }, []);

    const fetchSelectedAddress = async () => {
        try {
            const res = await API.get("/api/address/selected");
            setSelectedAddress(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchCart = async ( ) => {
        try {
            const res = await API.get("/api/cart")
            console.log("Payment Cart", res.data)
        } catch (error) {
            console.log(error)
        }
    }

    const handlePlaceOrder = async () => {
        try {

            if (!selectedAddress) {
                alert("Please Select Address")
                return;
            }
            await API.post("/api/order", {
                addressId: selectedAddress.addressId,
                paymentMethod: paymentMethod
            });

            navigate("/order-success");
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="container mt-4">

            <h3 className="mb-3">Select Payment Method</h3>

            <div className="card p-3 shadow-sm">

                <div className="form-check">
                    <input type="radio" value="COD" checked={paymentMethod === "COD"}
                        onChange={(e) => setPaymentMethod(e.target.value)} />
                    <label className="ms-2">Cash on Delivery</label>
                </div>

                <div className="form-check">
                    <input type="radio" value="UPI"
                        onChange={(e) => setPaymentMethod(e.target.value)} />
                    <label className="ms-2">UPI</label>
                </div>

                <div className="form-check">
                    <input type="radio" value="CARD"
                        onChange={(e) => setPaymentMethod(e.target.value)} />
                    <label className="ms-2">Credit / Debit Card</label>
                </div>

                <div className="form-check">
                    <input type="radio" value="NET_BANKING"
                        onChange={(e) => setPaymentMethod(e.target.value)} />
                    <label className="ms-2">Net Banking</label>
                </div>

                <button
                    className="btn btn-success mt-3"
                    onClick={handlePlaceOrder}
                >
                    Pay & Place Order
                </button>

            </div>

        </div>
    );
}

export default PaymentPage;